var map = {
	"assets/images/relics/BLM/relic_weapon-g_w_anima-p_w_lux.png": 2114,
	"assets/images/relics/BLM/relic_weapon-g_w_resistance-p_w_blade.png": 5832,
	"assets/images/relics/BLM/relic_weapon-g_w_zodiac-p_w_novus.png": 6297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8759;